export const DEFAULT_INPUT_WIDTH = 200;
export const FONT_SIZE = 14;
